/** The frontend tools' declared names: what the model calls, and the keys of the trail labels. */
export const FRONTEND_TOOL_NAMES = {
  recommendWhoDrug: "recommendWhoDrug",
  navigateTo: "navigateTo",
  goToField: "goToField",
  proposeFieldValue: "proposeFieldValue",
  highlightSource: "highlightSource",
  openPanel: "openPanel",
  closePanel: "closePanel",
  setFilter: "setFilter",
} as const;

export type FrontendToolName = (typeof FRONTEND_TOOL_NAMES)[keyof typeof FRONTEND_TOOL_NAMES];

/** Why a frontend tool refused; relayed to the model as the result's `code`. */
export const FRONTEND_TOOL_CODES = {
  outOfScope: "OUT_OF_SCOPE",
  invalidValue: "INVALID_VALUE",
  unknownTool: "UNKNOWN_TOOL",
  failed: "TOOL_FAILED",
} as const;

export type FrontendToolCode = (typeof FRONTEND_TOOL_CODES)[keyof typeof FRONTEND_TOOL_CODES];
